<template>
	<div class="blacklist-container">
		<SettingsLayout class="bg-white dark:bg-slate-900">
			<template #header>
				<div class="px-12 pt-4 bg-white dark:bg-slate-900">
					<woot-tabs
						class="tabs-wrapper [&_.tabs]:p-0 mb-4"
						:index="activeTab"
						@change="handleTabChange"
					>
						<woot-tabs-item
							v-for="(tab, index) in localizedTabs"
							:key="tab.key"
							:index="index"
							:name="tab.title"
							:show-badge="false"
						/>
					</woot-tabs>
				</div>
			</template>

			<template #body>
				<div class="settings-content bg-white dark:bg-slate-900">
					<keep-alive>
						<component
							:is="currentView"
							:key="activeTab"
							class="blacklist-content"
						/>
					</keep-alive>
				</div>
			</template>
		</SettingsLayout>
	</div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import SettingsLayout from '../SettingsLayout.vue';
import Index from './Index.vue';
import IpIndex from './IpIndex.vue';

const { t } = useI18n();

const tabs = [
	{ key: 'normal', titleKey: 'BLACKLIST.HEADER' },
	{ key: 'ip', titleKey: 'BLACKLIST.IP_BLACKLIST.TITLE' }
];

// 使用计算属性将标签标题转换为本地化文本
const localizedTabs = computed(() => {
	return tabs.map(tab => ({
		...tab,
		title: t(tab.titleKey)
	}));
});

const activeTab = ref(0);

const currentView = computed(() => (activeTab.value === 0 ? Index : IpIndex));

const handleTabChange = index => {
	activeTab.value = index;
};
</script>

<style lang="scss" scoped>
.blacklist-container {
	height: 100%;
}

.blacklist-content {
	height: 100%;
}

:deep(.tabs-wrapper) {
	.tabs-title {
		margin-right: 3rem;  
		
		a {
			font-size: 20px;
			font-weight: 600;
		}

		&:last-child {
			margin-right: 0;  
		}
	}
}
</style>
